import SignIn from 'global/components/auth/SignIn'
import { ModalPopup } from 'global/wrappers/ModalPopup'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { useContext, useState } from 'react'

const text = `
<p>
  If you want to <span class="highlight score">report a score</span> through <span class="highlight score">Thumbstat</span>, first find the <span class="highlight score">match</span> you want to update. Then <span class="highlight score score">long press</span> on that match (not just a simple click). A window will open where you can <span class="highlight score">submit</span> the score—quick and easy.
  </p>

<p>
  Then click on <span class="highlight score">Match Results</span>.
</p>

<p>
  You will need to be <span class="highlight score">signed into Thumbstat.</span>
</p>

<p>
  You will be then asked to select the type of match results you would like to enter (<span class="highlight score">Match Scores</span> or <span class="highlight score">Set Scores</span>).
</p>

<p>
  After that, <span class="highlight score">follow the prompts</span>.
</p>

<p>
  Your results submission <span class="highlight score">will</span> show up in the <span class="highlight score">match results</span>, but will <span class="highlight score">not</span> be reflected in the <span class="highlight score">standings</span> until the results are <span class="highlight score">confirmed</span> by Thumbstat.
</p>
`

export const GotScore = () => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { matches_info, teams_info } = sportsSeason_state ?? {}
  const { matches_combined } = matches_info ?? {}
  const { teams } = teams_info ?? {}

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const filterMatchesNoResultPastOrToday = (matches) => {
    if (!matches) return {};

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return _.pickBy(matches, (match) => {
      // ❌ Exclude if result exists
      if (_.has(match, 'result') && match.result) return false;

      // ❌ Exclude if no valid startDate
      if (!match?.startDate) return false;

      const parts = match.startDate.split('/');
      if (parts.length !== 3) return false;

      const [month, day, year] = parts;
      const matchDate = new Date(year, month - 1, day);

      // ❌ Invalid date
      if (isNaN(matchDate)) return false;

      // ✅ Include if today or past
      return matchDate <= today;
    });
  };

  const filteredMatches_all = _.pickBy(matches_combined, (match) => !match?.results);

  const filteredMatches_missing = filterMatchesNoResultPastOrToday(matches_combined)

  const [showText, setShowText] = useState()
  const [showSignIn, setShowSignIn] = useState()

  const handleShowText = () => {
    setShowText(!showText)
    setShowSignIn(false)
  }

  const handleShowSignIn = () => {
    setShowText(false)
    setShowSignIn(!showSignIn)
  }

  if (showText) {
    return <ModalPopup handleClose={handleShowText} handleSignIn={handleShowSignIn} text={text} />
    // return mdl({ handleClose: handleShowText, handleSignIn: handleShowSignIn })
  } else if (showSignIn) {
    return <SignIn handleCancel={handleShowSignIn} teams={teams} />
    // return mdl({handleClose: handleShowText, handleSignIn: handleShowSignIn })
  } else {
    return <div
      className='got-score'
      onClick={() => handleShowText()}
    >
      {'Score to report?'}
    </div>
  }
}
